import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'chart.js';
import axiosConn from 'config/axiosConn';

const LineCharts = ({ state }) => {
  console.log('state-------------------------line----', state);
  const canvasRef = useRef(null);
  const [chartData, setChartData] = useState({
    currentYear: {
      energySavedCounttheme: 0,
      adoptHealthyLifestylesCount: 0,
      adoptSustainableFoodSystemsCount: 0,
      reduceEWasteCount: 0,
      reduceWasteCount: 0,
      saveWaterCount: 0,
      sayNoToSingleUsePlasticCount: 0,
    },
    previousYear: {
      energySavedCounttheme: 0,
      adoptHealthyLifestylesCount: 0,
      adoptSustainableFoodSystemsCount: 0,
      reduceEWasteCount: 0,
      reduceWasteCount: 0,
      saveWaterCount: 0,
      sayNoToSingleUsePlasticCount: 0,
    },
  });

  const options = {
    type: 'line',
    data: {
      labels: [
        '',
        'Adopt Healthy Lifestyles',
        'Adopt Sustainable Food Systems',
        'Reduce E-Waste',
        'Reduce Waste',
        'Save Energy',
        'Save Water',
        'Say No to Single Use Plastic',
      ],
      datasets: [
        {
          label: 'Current Year',
          fill: false,
          lineTension: 0.3,
          pointBorderWidth: 2,
          borderColor: "#4caf50",
          data: [],
        },
        {
          label: 'Previous Year',
          fill: false,
          lineTension: 0.3,
          pointBorderWidth: 2,
          borderColor: "#ff9800",
          data: [],
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;

        if (state) {
          // Fetch data with state
          response = await axiosConn('post', 'dashboard-count', { state });
        } else {
          // Fetch data without state (for all states or default)
          response = await axiosConn('post', 'dashboard-count');
        }

        // console.log("API Response:", response);

        if (response.data.status === 'success') {
          setChartData({
            currentYear: {
              energySavedCounttheme: response.data.data.energySavedCount ?? 0,
              adoptHealthyLifestylesCount: response.data.data.lifestylesAdoptedCount ?? 0,
              adoptSustainableFoodSystemsCount: response.data.data.foodSystemsCount ?? 0,
              reduceEWasteCount: response.data.data.eWasteReducedCount ?? 0,
              reduceWasteCount: response.data.data.wasteReducedCount ?? 0,
              saveWaterCount: response.data.data.waterSavedCount ?? 0,
              sayNoToSingleUsePlasticCount: response.data.data.plasticReducedCount ?? 0,
            },
            previousYear: {
              energySavedCounttheme: response.data.data.previousYear?.energySavedCount ?? 0,
              adoptHealthyLifestylesCount: response.data.data.previousYear?.lifestylesAdoptedCount ?? 0,
              adoptSustainableFoodSystemsCount: response.data.data.previousYear?.foodSystemsCount ?? 0,
              reduceEWasteCount: response.data.data.previousYear?.eWasteReducedCount ?? 0,
              reduceWasteCount: response.data.data.previousYear?.wasteReducedCount ?? 0,
              saveWaterCount: response.data.data.previousYear?.waterSavedCount ?? 0,
              sayNoToSingleUsePlasticCount: response.data.data.previousYear?.plasticReducedCount ?? 0,
            },
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [state]);  // Re-fetch data when the `state` changes

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Initialize the chart
    const chart = new Chart(ctx, {
      ...options,
      data: {
        ...options.data,
        datasets: [
          {
            ...options.data.datasets[0],
            data: [
              '',
              chartData.currentYear.adoptHealthyLifestylesCount,
              chartData.currentYear.adoptSustainableFoodSystemsCount,
              chartData.currentYear.reduceEWasteCount,
              chartData.currentYear.reduceWasteCount,
              chartData.currentYear.energySavedCounttheme,
              chartData.currentYear.saveWaterCount,
              chartData.currentYear.sayNoToSingleUsePlasticCount,
            ],
          },
          {
            ...options.data.datasets[1],
            data: [
              '',
              chartData.previousYear.adoptHealthyLifestylesCount,
              chartData.previousYear.adoptSustainableFoodSystemsCount,
              chartData.previousYear.reduceEWasteCount,
              chartData.previousYear.reduceWasteCount,
              chartData.previousYear.energySavedCounttheme,
              chartData.previousYear.saveWaterCount,
              chartData.previousYear.sayNoToSingleUsePlasticCount,
            ],
          },
        ],
      },
    });

    return () => {
      chart.destroy();
    };
  }, [chartData]);

  return (
    <div style={{ width: '675px', height: '380px' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
    </div>
  );
};

export default LineCharts;
